import { IRpaDashboardUIPathState } from 'app/rpa-bots/core/IRpaBots';
import {EUIPathDashboardActions, UIPathDashboardActions} from '../actions/rpa-uipath-dashboard.actions';

export const initialStateRpaUIPathState: IRpaDashboardUIPathState = {
    isLoadingList: false,
    isLoadingDetail: false,
    isLoadingJobsData: false,
    isLoadingQueueitemsData: false,
    jobsList: null,
    queueitemsList: null,
    tokenConnection: null,
    jobRetried: null,
    queueitemRetried: null,
    queueName: '',
    jobsData: null,
    queueitemsData: null,
    isError: false,
    isLoadingJobsList: false,
    isLoadingQueueitemsList: false
}

export function RpaUIPathDashboardReducers(state = initialStateRpaUIPathState, action: UIPathDashboardActions): IRpaDashboardUIPathState {
    switch (action.type) {

        case EUIPathDashboardActions.getUIPathJobsList: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingJobsList: true
            };
            return newState;
        }

        case EUIPathDashboardActions.getUIPathJobsListSuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingJobsList: false,
                jobsList: action.payload
            };
            return newState;
        }

        case EUIPathDashboardActions.getUIPathQueueitemsList: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingQueueitemsList: true
            };
            return newState;
        }

        case EUIPathDashboardActions.getUIPathQueueitemsSuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingQueueitemsList: false,
                queueitemsList: action.payload
            };
            return newState;
        }

        case EUIPathDashboardActions.UIPathJobRetrySuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingDetail: true,
                jobRetried: action.payload
            }
            return newState;
        }

        case EUIPathDashboardActions.UIPathResetJobRetry: {
          const newState: IRpaDashboardUIPathState = {
              ...state,
             jobRetried: null
           }
          return newState;
        }

        case EUIPathDashboardActions.UIPathRetryQueueitemSuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingDetail: false,
                queueitemRetried:  action.payload
            }
            return newState;
        }

        case EUIPathDashboardActions.UIPathResetQueueitemRetry: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingDetail: false,
                queueitemRetried:  null
            }
            return newState;
        }

        case EUIPathDashboardActions.getUIPathJobsData: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingJobsData: true
            }
            return newState;
        }

        case EUIPathDashboardActions.getUIPathJobsDataSuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingJobsData: false,
                jobsData:  action.payload
            }
            return newState;
        }

        case EUIPathDashboardActions.getUIPathQueueitemsData: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingQueueitemsData: true
            }
            return newState;
        }

        case EUIPathDashboardActions.getUIPathQueueitemsDataSuccess: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isLoadingQueueitemsData: false,
                queueitemsData:  action.payload
            }
            return newState;
        }

        case EUIPathDashboardActions.resetDashboard: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                jobsData:null,
                queueitemsData:null
            };
            return newState;
        }

        case EUIPathDashboardActions.UIPathErrorHandler: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isError: true,
                isLoadingJobsData: false,
                isLoadingQueueitemsData: false    
            };
            return newState;
        }

        case EUIPathDashboardActions.UIPathResetErrorHandler: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                isError: false
            };
            return newState;
        }

        case EUIPathDashboardActions.resetRetries: {
            const newState: IRpaDashboardUIPathState = {
                ...state,
                jobRetried:null,
                queueitemRetried:null,
                jobsList:null,
                queueitemsList:null,
                isLoadingJobsList:false,
                isLoadingQueueitemsList:false
            };
            return newState;
        }

        default: {
            return state;
        }
    }
}
